import { lazy } from 'react-loosely-lazy';

export const LazyPortalSettingsSidebar = lazy(
    () => import(/* webpackChunkName: "portal-settings-sidebar" */ './portal-settings-sidebar')
);
